import DeparturesPage from './ApplicationsList'

export default DeparturesPage
